import CryptoJS from 'crypto-js';

const generateRandomVariableName = () => {
  const chars = 'abcdefghiklmnopqrstvxyzABCDEFGHIKLMNOPQRSTVXYZ_0123456789';
  const firstChars = 'abcdefghiklmnopqrstvxyzABCDEFGHIKLMNOPQRSTVXYZ_';
  
  const length = Math.floor(Math.random() * 4) + 6; // 6-9 characters
  let result = firstChars.charAt(Math.floor(Math.random() * firstChars.length));
  
  for (let i = 1; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return result;
};

const generateRandomKey = () => {
  const array = new Uint8Array(16); // 128 bits = 16 bytes
  window.crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

export const encryptCode = (plaintext, template) => {
  try {
    // Generate random key and variable names
    const keyHex = generateRandomKey();
    const var1 = generateRandomVariableName();
    const var2 = generateRandomVariableName();
    const var3 = generateRandomVariableName();
    
    // Convert key to CryptoJS format
    const key = CryptoJS.enc.Hex.parse(keyHex);
    const keyBase64 = CryptoJS.enc.Base64.stringify(key);
    
    // Encrypt the plaintext
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    
    const encryptedBase64 = encrypted.toString();
    
    // Replace placeholders in template
    return template
      .replace(/%1/g, var1)
      .replace(/%2/g, var2)
      .replace(/%3/g, var3)
      .replace(/%4/g, keyBase64)
      .replace(/%5/g, encryptedBase64);
  } catch (error) {
    console.error("Encryption error:", error);
    throw new Error("Failed to encrypt code. Please check your input.");
  }
};

export const decryptCode = (encryptedOutput) => {
  try {
    // Extract key and ciphertext using regex
    const keyMatch = encryptedOutput.match(/var\s+\w+\s*=\s*"([^"]+)"/);
    const ciphertextMatch = encryptedOutput.match(/decrypt\([^,]+,\s*[^,]+,\s*[^"]*"([^"]+)"/);
    
    if (!keyMatch || !ciphertextMatch) {
      throw new Error('Invalid encrypted format or missing key/ciphertext');
    }
    
    const keyBase64 = keyMatch[1];
    const encryptedBase64 = ciphertextMatch[1];
    
    // Parse key and decrypt
    const key = CryptoJS.enc.Base64.parse(keyBase64);
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    
    if (!decryptedText) {
      throw new Error('Decryption produced empty result (wrong key or corrupted data)');
    }
    
    return decryptedText;
  } catch (error) {
    console.error("Decryption error:", error);
    throw error;
  }
};